import { Menu } from "@headlessui/react";
import { FaAngleDown } from "react-icons/fa";
import { Link } from "react-router-dom";

const AdminDropdown = ({ user }) => {
  if (
    !user?.user_id ||
    (user.user_role !== "ac9be322-db89-4beb-854a-46f2c91de374" &&
      user.user_role !== "5aee1e31-cc95-49d9-9ed7-10c4e4b6fdef")
  ) {
    return null;
  }

  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button className="flex items-center space-x-2 py-1 px-4 rounded-lg text-[#484848] cursor-pointer text-base font-gotham hover:text-[#54B0AF]">
        <span>Admin</span>
        <FaAngleDown />
      </Menu.Button>

      <Menu.Items className="absolute left-0 mt-2 w-48 font-gotham text-base text-[#484848] bg-white border rounded-lg shadow-lg">
        <Menu.Item>
          {({ active }) => (
            <Link
              to="/PastChats"
              className={`block px-4 py-2 ${
                active ? "text-[#54B0AF]" : ""
              } rounded-lg`}
            >
              User History
            </Link>
          )}
        </Menu.Item>
        <Menu.Item>
          {({ active }) => (
            <Link
              to="/intention_technique"
              className={`block px-4 py-2 ${
                active ? "text-[#54B0AF]" : ""
              } rounded-lg`}
            >
              Intention & Technique
            </Link>
          )}
        </Menu.Item>
        <Menu.Item>
          {({ active }) => (
            <Link
              to="/config"
              className={`block px-4 py-2 ${
                active ? "text-[#54B0AF]" : ""
              } rounded-lg`}
            >
              Config
            </Link>
          )}
        </Menu.Item>
        <Menu.Item>
          {({ active }) => (
            <Link
              to="/blogPage"
              className={`block px-4 py-2 ${
                active ? "text-[#54B0AF]" : ""
              } rounded-lg`}
            >
              Blog Page
            </Link>
          )}
        </Menu.Item>
      </Menu.Items>
    </Menu>
  );
};

export default AdminDropdown;
